//#region Imports
import * as React from "react";
import { AnalyticsContext } from "../src/-private/AnalyticsContext";
import type { IAnalyticsContextValue } from "../src/IAnalyticsContextValue";
//#endregion

//#region Types
interface IProps {
  children?: React.ReactNode;
}
//#endregion

const analyticsContext: IAnalyticsContextValue = Object.freeze({
  track() {},
  UTM: Object.freeze({
    source: null,
  }),
});

export function AnalyticsProviderNoop(props: IProps) {
  return <AnalyticsContext.Provider value={analyticsContext}>{props.children}</AnalyticsContext.Provider>;
}
